'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { Modal } from 'shared/ui/Modal'
import { PATHS } from 'shared/utils/paths'

import { loginRedirectLocalStorage } from '../utils'

import LoginForm from './LoginForm'

interface LoginModalProps {
  open: boolean
  onClose: () => void
}

const LoginModal = ({ open, onClose }: LoginModalProps) => {
  const pathname = usePathname()

  useEffect(() => {
    if (open) {
      if (pathname === PATHS.cart) {
        loginRedirectLocalStorage.set(PATHS.delivery)
      } else {
        loginRedirectLocalStorage.set(pathname)
      }
    }
  }, [open, pathname])

  return (
    <>
      <Modal id='login-modal' onClose={onClose} open={open}>
        <LoginForm onModalClose={onClose} />
      </Modal>
    </>
  )
}

export default LoginModal
